require('./updateClientContactTimeStep2.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

//@core
const { formatText } = require('core/i18n').i18n;

//@components
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');

class UpdateClientContactTimeStep2 extends React.Component {

    render(){
        const { fromHourText, toHourText, step2Values } = this.props;
        const {operative, operativeResumeText, fromHourValue, toHourValue} = step2Values;
        const title = formatText("updateClientContactTimeStep2-title");

        return (
            <div className="update-client-contact-time-step2" id="printable-wizard">
                <h4 className="wizard-step--vertical__title">{title}</h4>
                <div className="update-client-contact-time__content">
                    <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                    <p>{operativeResumeText}</p>
                    <div className="update-client-contact-time__column">
                        <h5>{fromHourText}</h5>
                        <p>{fromHourValue}</p>
                    </div>
                    <div className="update-client-contact-time__column">
                        <h5>{toHourText}</h5>
                        <p>{toHourValue}</p>
                    </div>
                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                </div>
            </div>
        );
    }
}

UpdateClientContactTimeStep2.propTypes = {
    step2Values: PropTypes.object.isRequired,
    fromHourText: PropTypes.string.isRequired,
    toHourText: PropTypes.string.isRequired
}

module.exports = UpdateClientContactTimeStep2;
